import { render } from "./OidoGridColumn.vue?vue&type=template&id=b636dccc&scoped=true"
import script from "./OidoGridColumn.vue?vue&type=script&lang=js"
export * from "./OidoGridColumn.vue?vue&type=script&lang=js"

import "./OidoGridColumn.vue?vue&type=style&index=0&id=b636dccc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b636dccc"]])

export default __exports__